var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ElementRef, AfterViewInit, QueryList, OnInit, AfterContentInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CuiSwipeableActionDirective } from './swipeable-action.directive';
import { CuiBaseComponent } from '../shared/base-component';
import 'rxjs/add/observable/fromEvent';
import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/switchMap';
import { CuiIconService } from '../icon/icon.service';
var actionWidth = 80;
var activateThresholdPercent = .25;
var openThreshold = 100;
var CuiSwipeableComponent = /** @class */ (function (_super) {
    __extends(CuiSwipeableComponent, _super);
    function CuiSwipeableComponent(elementRef, iconService) {
        var _this = _super.call(this) || this;
        _this.elementRef = elementRef;
        _this.panning = false;
        _this.active = false;
        _this.panningPosition = 0;
        _this.panningDirection = 'left';
        iconService.useIcons([
            'icon/chevron-left-white',
            'icon/chevron-right-white'
        ]);
        return _this;
    }
    CuiSwipeableComponent.prototype.ngOnInit = function () {
        this.manager = new Hammer(this.elementRef.nativeElement, {
            recognizers: [
                [Hammer.Pan, { direction: Hammer.DIRECTION_HORIZONTAL }]
            ]
        });
    };
    CuiSwipeableComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
        this.manager.destroy();
    };
    CuiSwipeableComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var panStartSub = Observable.fromEvent(this.manager, 'panstart').subscribe(function (e) { return _this.handlePanStart(e); });
        var panSub = Observable.fromEvent(this.manager, 'panleft panright').subscribe(function (e) { return _this.handleHorizontalPan(e); });
        var panEndSub = Observable.fromEvent(this.manager, 'panend').subscribe(function (e) { return _this.handlePanEnd(e); });
        this.pushSubscription(panStartSub, panSub, panEndSub);
    };
    CuiSwipeableComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        var actions$ = Observable.merge(Observable.of(this.actions.toArray()), this.actions.changes);
        // Close the swipeable when an action is executed
        var activateSub = actions$
            .map(function (actions) { return actions.map(function (action) { return action.execute$; }); })
            .switchMap(function (execute) { return Observable.merge.apply(Observable, execute); })
            .subscribe(function () { return _this.close(); });
        // Populate leftActions and rightActions
        var parseSub = actions$.subscribe(function () { return _this.parseActions(); });
        this.pushSubscription(activateSub, parseSub);
    };
    CuiSwipeableComponent.prototype.close = function () {
        this.panningPosition = 0;
        this.setPosition(this.panningPosition);
    };
    CuiSwipeableComponent.prototype.parseActions = function () {
        this.leftActions = this.actions.filter(function (action) { return action.position === 'left'; });
        this.rightActions = this.actions.filter(function (action) { return action.position === 'right'; });
    };
    CuiSwipeableComponent.prototype.handlePanStart = function (e) {
        if (Math.abs(e.deltaY) < 10) {
            this.panning = true;
        }
    };
    CuiSwipeableComponent.prototype.handleHorizontalPan = function (e) {
        if (!this.panning) {
            return;
        }
        if (this.leftActions.length > 0 && this.panningPosition + e.deltaX > 0) {
            this.panningDirection = 'left';
        }
        if (this.rightActions.length > 0 && this.panningPosition + e.deltaX < 0) {
            this.panningDirection = 'right';
        }
        var position = this.panningPosition + e.deltaX;
        var direction = position >= 0 ? 1 : -1;
        var actions = position < 0 ? this.rightActions.length : this.leftActions.length;
        this.active = actions > 1 || Math.abs(position) > window.innerWidth * activateThresholdPercent;
        if (actions === 1 || actions > 1 && Math.abs(position) < actionWidth * actions) {
            this.setPosition(this.panningPosition + e.deltaX);
        }
        else if (actions > 1) {
            this.setPosition(actionWidth * actions * direction);
        }
        else {
            this.setPosition(0);
        }
    };
    CuiSwipeableComponent.prototype.handlePanEnd = function (e) {
        if (!this.panning) {
            return;
        }
        this.panning = false;
        var position = this.panningPosition + e.deltaX;
        var direction = position >= 0 ? 1 : -1;
        var actions = position < 0 ? this.rightActions.length : this.leftActions.length;
        if (actions === 1 && Math.abs(position) > window.innerWidth * activateThresholdPercent) {
            var action = direction > 0 ? this.leftActions[0] : this.rightActions[0];
            action.execute();
        }
        else if (actions > 1 && Math.abs(position) > openThreshold) {
            this.panningPosition = actionWidth * actions * direction;
            this.setPosition(this.panningPosition);
        }
        else {
            this.close();
        }
    };
    CuiSwipeableComponent.prototype.setPosition = function (position) {
        var _this = this;
        requestAnimationFrame(function () { return _this.itemContainer.nativeElement.style.transform = "translate3d(" + position + "px, 0 , 0)"; });
    };
    return CuiSwipeableComponent;
}(CuiBaseComponent));
export { CuiSwipeableComponent };



// WEBPACK FOOTER //
// ./node_modules/@cicero/webui/lib/core/swipeable/swipeable.component.ts.pre-build-optimizer.js